import { Injectable } from '@angular/core';

// define the localStorage properties to be used
enum storageProperties {
	accessToken = 'access_token',
	expiresAt = 'expires_at',
	idToken = 'id_token',
	lastActivity = 'last_activity',
	activityTimeout = 'activity_timeout',
	email = 'email',
}

@Injectable({
	providedIn: 'root',
})
export class LocalStorageService {
	private activityTimeoutDiff: number;
	constructor() {
		this.activityTimeoutDiff = 3600000; // 1 hour in miliseconds
	}

	// Access Token getter and setter
	// Used to store the Access Token from auth0
	getAccessToken() {
		return localStorage.getItem(storageProperties.accessToken);
	}

	setAccessToken(accessToken: any) {
		localStorage.setItem(storageProperties.accessToken, accessToken);
	}

	// Expires At getter and setter
	// Used to store the expiration time of the Access Token
	getExpirestAt() {
		return JSON.parse(localStorage.getItem(storageProperties.expiresAt));
	}

	setExpiresAt(expiresAt: any) {
		localStorage.setItem(storageProperties.expiresAt, JSON.stringify(expiresAt));
	}

	// Id Token getter and setter
	// Used to store the Id Token from auth0
	getIdToken() {
		return JSON.parse(localStorage.getItem(storageProperties.idToken));
	}

	setIdToken(idToken: any) {
		localStorage.setItem(storageProperties.idToken, idToken);
	}

	// Email getter and setter
	// Used to store the email from localstorage
	getUserEmail() {
		return localStorage.getItem(storageProperties.email);
	}

	setUserEmail(email: string) {
		localStorage.setItem(storageProperties.email, email);
	}

	// Last Activity Getter and Setter
	// Used to store the time of the last API call
	getLastActivity() {
		return JSON.parse(localStorage.getItem(storageProperties.lastActivity));
	}

	setLastActivity(lastActivity: any) {
		this.setActivityTimeout(lastActivity);
		localStorage.setItem(storageProperties.lastActivity, JSON.stringify(lastActivity));
	}

	// Activity Timeout Getter and Setter
	// Used to store the time of when a user will timeout of the application
	getActivityTimeout() {
		return JSON.parse(localStorage.getItem(storageProperties.activityTimeout));
	}

	private setActivityTimeout(activityTimeout: any) {
		activityTimeout = activityTimeout + this.activityTimeoutDiff;
		localStorage.setItem(storageProperties.activityTimeout, JSON.stringify(activityTimeout));
	}

	// Clears all localstorage properties
	clearStorage() {
		for (const property in storageProperties) {
			if (property) {
				localStorage.removeItem(storageProperties[property]);
			}
		}
	}
}
